import { createContext } from 'react';
import { TableContextProps } from './Table.types';

// TODO: See if it's possible to use unknown instead
// @ts-expect-error TS2345 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
const TableContext = createContext<TableContextProps<any>>(undefined);

export default TableContext;
